import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import s from './InstallPredefinedTemplateModal.scss'
import { getBaseUrl } from 'utils/api'

const InstallPredefinedTemplateModal = ({
  selectedPrefinedTemplate,
  setSelectedPrefinedTemplate,
  installTemplate
}) => {
  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={!!selectedPrefinedTemplate}
        toggle={() => {
          setSelectedPrefinedTemplate(null)
        }}
        size="lg"
      >
        <ModalHeader
          toggle={() => {
            setSelectedPrefinedTemplate(null)
          }}
          className={s.modalHeader}
        >
          Install Proposal Template
        </ModalHeader>
        <ModalBody>
          <>
            <p>Template Name: {selectedPrefinedTemplate.title}</p>
            <div style={{ textAlign: 'center' }}>
              <img className={s.image} src={getBaseUrl(selectedPrefinedTemplate.largeImageUrl)} />
            </div>
          </>
        </ModalBody>
        <ModalFooter>
          <Button className={s.saveBtn} onClick={installTemplate}>
            Install this Template
          </Button>
          <Button color="secondary" onClick={() => setSelectedPrefinedTemplate(null)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default InstallPredefinedTemplateModal
